import { ENUM__redux_action } from '@/state/_base/ENUM__redux_action';
import { PayloadAction } from '@reduxjs/toolkit';
import { assert_hash_sha256_not_empty } from '@shared/asserts/utils_asserts';
import { STATE__images } from '../STATE__images';

export const LOCAL__images_add_to_loading_pool = (payload: string[]): PayloadAction<string[]> => ({
  type: ENUM__redux_action.IMAGES_ADD_TO_LOADING_POOL,
  payload,
});

export function INIT_LOCAL__images_add_to_loading_pool(state: STATE__images, action: PayloadAction<string[]>) {
  let hashes_to_load = action.payload;

  if (hashes_to_load.length == 0) return;

  let { images_hashes_loading, images_map } = state;

  let hashes_to_load_filtered = new Set<string>();

  for (let hash_sha256_content of hashes_to_load) {
    if (images_hashes_loading.has(hash_sha256_content)) continue; //already in loading pool
    if (images_map.has(hash_sha256_content)) continue; //already loaded

    assert_hash_sha256_not_empty(hash_sha256_content);

    hashes_to_load_filtered.add(hash_sha256_content);
  }

  if (hashes_to_load_filtered.size == 0) return; //nothing to load

  //merge with existing hashes
  state.images_hashes_loading = new Set([...hashes_to_load_filtered, ...images_hashes_loading]);
}
